<script>
  export let currentUrl
</script>
<a href="https://empleo.fefarcan.org/?o={currentUrl}" target="_blank"
rel="noopener" class="bannerLg">
  <div class="logo">
    <img
      src="/img/bolsa-de-empleo-federacion-de-farmacias-de-Canarias.svg"
      alt="Fefarcan empleo: la bolsa de empleo de la farmacia canaria"
    />
  </div>
  <div class="circle">&nbsp;</div>
  <div class="text">
    <h1>La Bolsa de Empleo</h1>
    <h1>de la Farmacia Canaria</h1>
    <h1>¿Quieres trabajar en Canarias?</h1>
    <h1><small>accede a nuestra bolsa de empleo</small></h1>
  </div>
  <div class="btnAndUrlWrapper">
    <a
      href="https://empleo.fefarcan.org/?o={currentUrl}"
      class="btn"
      target="_blank"
      rel="noopener">Registra tu CV</a
    >
    <a
      href="https://empleo.fefarcan.org/?o={currentUrl}"
      class="url"
      target="_blank"
      rel="noopener">https://empleo.fefarcan.org</a
    >
  </div>
</a>

<style>

  .circle {
    background-image: url("/img/circulo_banner_empleo.svg");
    width: clamp(160px, 24vw, 235px);
    height: 100%;
    background-position-y: center;
    background-position-x: right;
    animation-name: slideFromLeft, growAndShrink;
    animation-duration: 800ms, 1.2s;
    animation-delay: 400ms, 6s;
    animation-fill-mode: both;
  }
  .btnAndUrlWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-right: clamp(5px, 2.8vw, 30px);
  }
  .btn {
    background: white;
    color: rgb(208, 42, 111);
    display: block;
    border-radius: 5px;
    padding: 10px 15px;
    text-align: center;
    font-weight: bold;
    border: 2px solid #0088a9;
    box-shadow: rgb(255 255 255) 0 0 15px;
    transform: scale3d(0, 0, 0);
    animation-fill-mode: forwards;
    animation-name: scaleUp, fadeOut, scaleUp;
    animation-duration: 1s, 300ms, 1s;
    animation-delay: 2s, 6s, 9s;
    animation-iteration-count: initial;
  }
  .url,
  .url:hover {
    color: #ffffff;
    text-decoration: none;
    font-size: clamp(12px, 1.8vw, 16px);
    opacity: 0;
    animation-fill-mode: forwards;
    animation-name: fadeIn, fadeOut, fadeIn;
    animation-duration: 1s, 300ms, 1s;
    animation-delay: 2s, 6s, 9s;
    animation-iteration-count: initial;
  }
  .bannerLg,  .bannerLg:hover  {
    opacity: 1;
    text-decoration: none;
    position: relative;
    width: clamp(600px, 100%, 970px);
    height: 90px;
    background-color: #0088a9;
    display: flex;
    flex-direction: row;
    padding-right: 5px;
    border: 1px solid #0088a9;
    overflow: hidden;
    margin: auto;
    animation-name: fadeIn, fadeOut;
    animation-fill-mode: forwards;
    animation-duration: 800ms, 800ms;
    animation-delay: 0s, 14s;
  }
  .text {
    flex-grow: 1;
    min-width: 315px;
  }
  h1 {
    color: #ffffff;
    margin: 5px 0;
    font-family: Ubuntu;
    font-weight: 400;
    font-size: clamp(20px, 3vw, 34px);
    text-align: center;
    animation-name: slideFromTop, removeFromScene;
    animation-fill-mode: both;
    animation-iteration-count: initial;
    margin-top: -200px;
  }
  .text h1:first-child {
    padding-top: 5px;
    animation-duration: 1300ms, 100ms;
    animation-delay: 500ms, 6050ms;
  }
  .text h1:nth-child(2) {
    animation-duration: 1500ms, 100ms;
    animation-delay: 1200ms, 6050ms;
  }
  .text h1:nth-child(3) {
    padding-top: 15px;
    font-size: clamp(20px, 2.5vw, 27px);
    animation-name: slideFromTop;
    animation-duration: 1300ms;
    animation-delay: 6800ms;
  }
  .text h1:nth-child(4) {
    margin: 15px 0;
    font-size: clamp(20px, 2.5vw, 27px);
    animation-name: slideFromTop;
    animation-duration: 1500ms;
    animation-delay: 7500ms;
  }
  .logo {
    padding: 5px;
    z-index: 2;
    width: clamp(130px, 17vw, 195px);
    position: absolute;
    animation-duration: 1000ms;
    animation-name: slideFromTop;
    animation-delay: 600ms;
    animation-fill-mode: both;
    margin-top: -200px;
    align-self: center;
  }
  .logo img {
    width: 100%;
  }
</style>
